import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "d-inline ms-2" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    class: "progress mb-3",
    role: "progressbar",
    "aria-label": "Basic example",
    "aria-valuemin": "0",
    "aria-valuemax": "100"
};
const _hoisted_4 = { class: "d-flex mb-3" };
const _hoisted_5 = {
    class: "list-group list-group-flush",
    role: "tablist",
    "aria-orientation": "vertical"
};
const _hoisted_6 = ["id", "data-bs-target"];
const _hoisted_7 = ["id", "data-bs-target"];
const _hoisted_8 = ["id", "data-bs-target"];
const _hoisted_9 = ["id", "data-bs-target"];
const _hoisted_10 = ["id", "data-bs-target"];
const _hoisted_11 = ["id", "data-bs-target"];
const _hoisted_12 = { class: "tab-content px-5" };
const _hoisted_13 = ["id"];
const _hoisted_14 = { class: "fw-bold" };
const _hoisted_15 = { class: "form-floating mb-3" };
const _hoisted_16 = ["id"];
const _hoisted_17 = {
    value: "",
    selected: ""
};
const _hoisted_18 = { value: "-1" };
const _hoisted_19 = { value: "1" };
const _hoisted_20 = { value: "2" };
const _hoisted_21 = { value: "3" };
const _hoisted_22 = ["for"];
const _hoisted_23 = { key: 0 };
const _hoisted_24 = { class: "mb-3" };
const _hoisted_25 = {
    class: "position-relative w-100 text-center border-start-3 border-top-0 border-secondary d-flex align-items-center justify-content-center rounded-bottom p-3",
    style: { "cursor": "pointer", "border-style": "dashed !important" }
};
const _hoisted_26 = { class: "fw-bold text-primary mb-0" };
const _hoisted_27 = {
    key: 1,
    class: "fw-bold text-success d-inline-flex align-items-center mb-3"
};
const _hoisted_28 = { class: "ms-2" };
const _hoisted_29 = { key: 2 };
const _hoisted_30 = { class: "row" };
const _hoisted_31 = { class: "col-4" };
const _hoisted_32 = ["id"];
const _hoisted_33 = { class: "form-floating mb-3" };
const _hoisted_34 = ["id"];
const _hoisted_35 = ["for"];
const _hoisted_36 = { class: "col-4" };
const _hoisted_37 = ["id"];
const _hoisted_38 = { class: "form-floating mb-3" };
const _hoisted_39 = ["id"];
const _hoisted_40 = ["for"];
const _hoisted_41 = { class: "col-4" };
const _hoisted_42 = ["id"];
const _hoisted_43 = { class: "form-floating mb-3" };
const _hoisted_44 = ["id"];
const _hoisted_45 = ["for"];
const _hoisted_46 = {
    key: 3,
    class: "form-floating mb-3"
};
const _hoisted_47 = ["id"];
const _hoisted_48 = {
    value: "",
    selected: ""
};
const _hoisted_49 = ["value"];
const _hoisted_50 = ["for"];
const _hoisted_51 = ["id"];
const _hoisted_52 = { class: "fw-bold" };
const _hoisted_53 = { class: "form-floating" };
const _hoisted_54 = ["id"];
const _hoisted_55 = {
    value: "",
    selected: ""
};
const _hoisted_56 = { value: "-1" };
const _hoisted_57 = { value: "1" };
const _hoisted_58 = { value: "2" };
const _hoisted_59 = ["for"];
const _hoisted_60 = ["id"];
const _hoisted_61 = { class: "fw-bold" };
const _hoisted_62 = { class: "form-floating" };
const _hoisted_63 = ["id"];
const _hoisted_64 = {
    value: "",
    selected: ""
};
const _hoisted_65 = ["value"];
const _hoisted_66 = ["for"];
const _hoisted_67 = ["id"];
const _hoisted_68 = { class: "fw-bold" };
const _hoisted_69 = { class: "form-floating" };
const _hoisted_70 = ["id"];
const _hoisted_71 = {
    value: "",
    selected: ""
};
const _hoisted_72 = { value: "-1" };
const _hoisted_73 = ["value"];
const _hoisted_74 = ["for"];
const _hoisted_75 = ["id"];
const _hoisted_76 = { class: "fw-bold" };
const _hoisted_77 = { class: "form-floating mb-3" };
const _hoisted_78 = ["id"];
const _hoisted_79 = {
    value: "",
    selected: ""
};
const _hoisted_80 = ["value"];
const _hoisted_81 = ["for"];
const _hoisted_82 = ["id"];
const _hoisted_83 = { class: "fw-bold" };
const _hoisted_84 = { class: "form-floating mb-3" };
const _hoisted_85 = ["id"];
const _hoisted_86 = {
    value: "",
    selected: ""
};
const _hoisted_87 = { value: "-1" };
const _hoisted_88 = ["value"];
const _hoisted_89 = ["for"];
const _hoisted_90 = {
    key: 0,
    class: "text-center"
};
const _hoisted_91 = { class: "w-100 d-flex justify-content-center mb-3" };
const _hoisted_92 = ["disabled"];
const _hoisted_93 = { class: "d-inline ms-2" };
const _hoisted_94 = {
    key: 1,
    class: "fw-bold border-bottom mb-3 pb-2"
};
const _hoisted_95 = { key: 2 };
const _hoisted_96 = { class: "row row-cols-3 g-4" };
const _hoisted_97 = { class: "col d-flex align-items-center justify-content-center" };
const _hoisted_98 = ["onClick"];
const _hoisted_99 = ["src"];
const _hoisted_100 = { key: 1 };
const _hoisted_101 = { class: "bg-primary d-flex align-items-center justify-content-center flex-column rounded-3 p-5" };
const _hoisted_102 = ["innerHTML"];
const _hoisted_103 = { key: 0 };
const _hoisted_104 = { class: "bg-danger d-flex align-items-center justify-content-center rounded-3 p-3" };
const _hoisted_105 = { class: "fs-5 fw-bold text-white text-center" };
import { onMounted, ref, watch } from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import { loadTenantConfigs } from '../Composables/standardFunctions';
import { useI18n } from 'vue-i18n';
import { useTrans } from '@/Composables/useTrans';
import ContextModal from '../Components/ContextModal.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AiImageManager',
    props: {
        configurationComponentId: String,
        modalTargetOnClose: String,
    },
    emits: ['selectImage', 'opened', 'closed'],
    setup(__props, { emit: __emit }) {
        const { t } = useI18n();
        const { trans } = useTrans();
        const props = __props;
        const emit = __emit;
        const instanceId = Math.random().toString(36).substring(2, 7);
        const maxFileSize = ref(10240000); //logo upload
        const colorSelection = ref('');
        const color1 = ref(null);
        const color2 = ref(null);
        const color3 = ref(null);
        const logoUploaded = ref(false);
        const colorSchemeSelection = ref('');
        const fileInput = ref(null);
        const printAreaSelection = ref('');
        const topicSelection = ref('');
        const designTypeSelection = ref('');
        const industrySelection = ref('');
        const companyDescription = ref(null);
        const applicationAreaSelection = ref('');
        const progress = ref(0);
        const colorSchemes = ref([]);
        const designTopics = ref([]);
        const designTypes = ref([]);
        const industries = ref([]);
        const applicationAreas = ref([]);
        const generatedImages = ref([]);
        const modal = ref();
        watch([
            colorSelection,
            color1,
            color2,
            color3,
            colorSchemeSelection,
            fileInput,
            printAreaSelection,
            topicSelection,
            designTypeSelection,
            industrySelection,
            applicationAreaSelection,
        ], () => {
            let completedSteps = 0;
            const totalSteps = 6;
            if (colorSelection.value == '-1') {
                completedSteps++;
            }
            if (colorSelection.value === '1' && (color1.value || color2.value || color3.value)) {
                completedSteps++;
            }
            if (colorSelection.value === '2' && colorSchemeSelection.value) {
                completedSteps++;
            }
            if (colorSelection.value === '3' && (color1.value || color2.value || color3.value)) {
                completedSteps++;
            }
            if (printAreaSelection.value)
                completedSteps++;
            if (topicSelection.value)
                completedSteps++;
            if (designTypeSelection.value)
                completedSteps++;
            if (industrySelection.value)
                completedSteps++;
            if (applicationAreaSelection.value)
                completedSteps++;
            progress.value = (completedSteps / totalSteps) * 100;
        }, { immediate: true });
        const loading = ref(false);
        const error = ref(null);
        onMounted(async () => {
            colorSchemes.value = await loadOptions(1);
            designTopics.value = await loadOptions(2);
            designTypes.value = await loadOptions(3);
            industries.value = await loadOptions(4);
            applicationAreas.value = await loadOptions(5);
            loadGeneratedImages();
            maxFileSize.value = (await loadTenantConfigs('max_image_upload_size')) * 1000;
        });
        async function uploadImage() {
            const file = fileInput.value?.files?.[0];
            if (file) {
                loading.value = true;
                try {
                    checkImageSize(file);
                }
                catch (error) {
                    if (error instanceof Error) {
                        console.error(error.message);
                        showError(error.message);
                    }
                    else {
                        console.error(error);
                    }
                    loading.value = false;
                    return;
                }
                const formData = new FormData();
                formData.append('image', file);
                axios.post(route('configurator.printConfiguration.aiImages.logoUpload', props.configurationComponentId), formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                    .then(function (response) {
                    if (response.status == 200) {
                        logoUploaded.value = true;
                        color1.value = response.data.colors[0] ?? null;
                        color2.value = response.data.colors[1] ?? null;
                        color3.value = response.data.colors[2] ?? null;
                    }
                    fileInput.value = null;
                    loading.value = false;
                })
                    .catch(function (error) {
                    console.log(error);
                    loading.value = false;
                    showError(error);
                });
            }
        }
        function checkImageSize(file) {
            if (file) {
                if (file.size > maxFileSize.value) {
                    throw new Error(t('Datei ist zu groß. Max. Dateigröße:') + ' ' + (maxFileSize.value / 1000) + ' KB');
                }
            }
        }
        function generateAiImages() {
            let timerInterval;
            Swal.fire({
                title: t("Einen Moment bitte!"),
                html: trans("Ihre Grafiken werden generiert: <b></b> Sekunden."),
                timer: 60000,
                timerProgressBar: true,
                didOpen: () => {
                    Swal.showLoading();
                    const timer = Swal.getPopup().querySelector("b");
                    timerInterval = setInterval(() => {
                        timer.textContent = `${(Swal.getTimerLeft() / 1000).toFixed(0)}`;
                    }, 100);
                },
                willClose: () => {
                    clearInterval(timerInterval);
                }
            }).then((result) => {
            });
            axios.post(route('configurator.printConfiguration.aiImages.store', {
                configurationComponentId: props.configurationComponentId,
            }), {
                colorSelection: colorSelection.value,
                color1: color1.value,
                color2: color2.value,
                color3: color3.value,
                colorSchemeSelection: colorSchemeSelection.value,
                printAreaSelection: printAreaSelection.value,
                topicSelection: topicSelection.value,
                designTypeSelection: designTypeSelection.value != '-1' ? designTypeSelection.value : designTypes.value[Math.floor(Math.random() * designTypes.value.length)].id,
                industrySelection: industrySelection.value,
                companyDescription: companyDescription.value,
                applicationAreaSelection: applicationAreaSelection.value,
            })
                .then(function (response) {
                if (response.status == 200) {
                    loadGeneratedImages();
                }
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function loadOptions(typeId) {
            return axios.post(route('configurator.aiImageOptions.load', {
                aiImageOptionType: typeId,
            }))
                .then(function (response) {
                return response.data;
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function loadGeneratedImages() {
            axios.post(route('configurator.printConfiguration.aiImages.load', {
                configurationComponentId: props.configurationComponentId,
            }), {})
                .then(function (response) {
                generatedImages.value = response.data;
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function selectImage(uuid) {
            axios.post(route('configurator.printConfiguration.images.storeAi', {
                configurationComponentId: props.configurationComponentId,
            }), {
                aiImageUuid: uuid,
            })
                .then(function (response) {
                emit('selectImage', response.data);
            })
                .catch(function (error) {
                console.log(error);
            });
        }
        function showError(text) {
            error.value = text;
            setTimeout(() => {
                error.value = null;
            }, 3000);
        }
        function openModal(event) {
            modal.value.open(event);
            emit('opened');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("button", {
                    class: "btn btn-primary d-inline-flex align-items-center m-2",
                    onClick: _cache[0] || (_cache[0] = ($event) => (openModal($event)))
                }, [
                    _cache[15] || (_cache[15] = _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: "16",
                        height: "16",
                        fill: "currentColor",
                        class: "bi bi-stars",
                        viewBox: "0 0 16 16"
                    }, [
                        _createElementVNode("path", { d: "M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.73 1.73 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.73 1.73 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.73 1.73 0 0 0 3.407 2.31zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z" })
                    ], -1)),
                    _createElementVNode("span", _hoisted_1, _toDisplayString(_unref(t)('Grafiken generieren')), 1)
                ]),
                _createVNode(ContextModal, {
                    ref_key: "modal",
                    ref: modal,
                    id: 'aiConfigurationImages' + _unref(instanceId),
                    closeButton: _unref(t)('weiter'),
                    zIndex: 1051,
                    size: 'lg'
                }, {
                    default: _withCtx(() => [
                        (!loading.value && error.value == null)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("div", {
                                        class: "progress-bar",
                                        style: _normalizeStyle({ width: progress.value + '%' })
                                    }, null, 4)
                                ]),
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("button", {
                                            class: "list-group-item active",
                                            id: 'colors-tab' + _unref(instanceId),
                                            "data-bs-toggle": "pill",
                                            "data-bs-target": '#pills-colors' + _unref(instanceId),
                                            type: "button",
                                            role: "tab"
                                        }, _toDisplayString(_unref(t)('Farben')), 9, _hoisted_6),
                                        _createElementVNode("button", {
                                            class: "list-group-item",
                                            id: 'print-area-tab' + _unref(instanceId),
                                            "data-bs-toggle": "pill",
                                            "data-bs-target": '#pills-print-area' + _unref(instanceId),
                                            type: "button",
                                            role: "tab"
                                        }, _toDisplayString(_unref(t)('Druck-Bereich')), 9, _hoisted_7),
                                        _createElementVNode("button", {
                                            class: "list-group-item",
                                            id: 'design-topic-tab' + _unref(instanceId),
                                            "data-bs-toggle": "pill",
                                            "data-bs-target": '#pills-design-topic' + _unref(instanceId),
                                            type: "button",
                                            role: "tab"
                                        }, _toDisplayString(_unref(t)('Design-Thema')), 9, _hoisted_8),
                                        _createElementVNode("button", {
                                            class: "list-group-item",
                                            id: 'design-type-tab' + _unref(instanceId),
                                            "data-bs-toggle": "pill",
                                            "data-bs-target": '#pills-design-type' + _unref(instanceId),
                                            type: "button",
                                            role: "tab"
                                        }, _toDisplayString(_unref(t)('Design-Stil')), 9, _hoisted_9),
                                        _createElementVNode("button", {
                                            class: "list-group-item",
                                            id: 'your-company-tab' + _unref(instanceId),
                                            "data-bs-toggle": "pill",
                                            "data-bs-target": '#pills-your-company' + _unref(instanceId),
                                            type: "button",
                                            role: "tab"
                                        }, _toDisplayString(_unref(t)('Ihr Unternehmen')), 9, _hoisted_10),
                                        _createElementVNode("button", {
                                            class: "list-group-item",
                                            id: 'application-area-tab' + _unref(instanceId),
                                            "data-bs-toggle": "pill",
                                            "data-bs-target": '#pills-application-area' + _unref(instanceId),
                                            type: "button",
                                            role: "tab"
                                        }, _toDisplayString(_unref(t)('Anwendungsbereich')), 9, _hoisted_11)
                                    ]),
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("div", {
                                            class: "tab-pane fade show active",
                                            id: 'pills-colors' + _unref(instanceId),
                                            role: "tabpanel",
                                            tabindex: "0"
                                        }, [
                                            _createElementVNode("p", _hoisted_14, _toDisplayString(_unref(t)('Welche Farben sollen verwendet werden?')), 1),
                                            _createElementVNode("div", _hoisted_15, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: 'colorSelection-' + _unref(instanceId),
                                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((colorSelection).value = $event)),
                                                    required: ""
                                                }, [
                                                    _createElementVNode("option", _hoisted_17, _toDisplayString(_unref(t)('Bitte Auswahl treffen')), 1),
                                                    _createElementVNode("option", _hoisted_18, _toDisplayString(_unref(t)('Egal')), 1),
                                                    _createElementVNode("option", _hoisted_19, _toDisplayString(_unref(t)('Farbauswahl')), 1),
                                                    _createElementVNode("option", _hoisted_20, _toDisplayString(_unref(t)('Farbschema')), 1),
                                                    _createElementVNode("option", _hoisted_21, _toDisplayString(_unref(t)('Logo-Upload mit Farb-Extraktion')), 1)
                                                ], 8, _hoisted_16), [
                                                    [_vModelSelect, colorSelection.value]
                                                ]),
                                                _createElementVNode("label", {
                                                    for: 'colorSelection-' + _unref(instanceId)
                                                }, _toDisplayString(_unref(t)('Farbauswahl')), 9, _hoisted_22)
                                            ]),
                                            (colorSelection.value == '3')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                    _createElementVNode("form", _hoisted_24, [
                                                        _createElementVNode("label", _hoisted_25, [
                                                            _createElementVNode("input", {
                                                                type: "file",
                                                                ref_key: "fileInput",
                                                                ref: fileInput,
                                                                onChange: uploadImage,
                                                                class: "position-absolute w-100 h-100",
                                                                style: { "opacity": "0" }
                                                            }, null, 544),
                                                            _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(t)('Klicken oder Logo hineinziehen')), 1)
                                                        ])
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (logoUploaded.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                                    _cache[16] || (_cache[16] = _createElementVNode("svg", {
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        height: "20",
                                                        fill: "currentColor",
                                                        class: "bi bi-check2-circle",
                                                        viewBox: "0 0 16 16"
                                                    }, [
                                                        _createElementVNode("path", { d: "M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0" }),
                                                        _createElementVNode("path", { d: "M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0z" })
                                                    ], -1)),
                                                    _createElementVNode("span", _hoisted_28, _toDisplayString(_unref(t)('Logo-Farben erfasst!')), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (colorSelection.value == '1' || logoUploaded.value)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                                    _createElementVNode("div", _hoisted_30, [
                                                        _createElementVNode("div", _hoisted_31, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "color",
                                                                class: "form-control form-control-color w-100 mb-2",
                                                                id: 'colorPicker1' + _unref(instanceId),
                                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((color1).value = $event))
                                                            }, null, 8, _hoisted_32), [
                                                                [_vModelText, color1.value]
                                                            ]),
                                                            _createElementVNode("div", _hoisted_33, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                    type: "email",
                                                                    class: "form-control",
                                                                    id: 'color1' + _unref(instanceId),
                                                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((color1).value = $event))
                                                                }, null, 8, _hoisted_34), [
                                                                    [_vModelText, color1.value]
                                                                ]),
                                                                _createElementVNode("label", {
                                                                    for: 'color1' + _unref(instanceId)
                                                                }, "1. " + _toDisplayString(_unref(t)('Farbe')) + " (Hex-Code)", 9, _hoisted_35)
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_36, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "color",
                                                                class: "form-control form-control-color w-100 mb-2",
                                                                id: 'colorPicker2' + _unref(instanceId),
                                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((color2).value = $event))
                                                            }, null, 8, _hoisted_37), [
                                                                [_vModelText, color2.value]
                                                            ]),
                                                            _createElementVNode("div", _hoisted_38, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                    type: "email",
                                                                    class: "form-control",
                                                                    id: 'color2' + _unref(instanceId),
                                                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((color2).value = $event))
                                                                }, null, 8, _hoisted_39), [
                                                                    [_vModelText, color2.value]
                                                                ]),
                                                                _createElementVNode("label", {
                                                                    for: 'color2' + _unref(instanceId)
                                                                }, "2. " + _toDisplayString(_unref(t)('Farbe')) + " (Hex-Code)", 9, _hoisted_40)
                                                            ])
                                                        ]),
                                                        _createElementVNode("div", _hoisted_41, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                type: "color",
                                                                class: "form-control form-control-color w-100 mb-2",
                                                                id: 'colorPicker3' + _unref(instanceId),
                                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((color3).value = $event))
                                                            }, null, 8, _hoisted_42), [
                                                                [_vModelText, color3.value]
                                                            ]),
                                                            _createElementVNode("div", _hoisted_43, [
                                                                _withDirectives(_createElementVNode("input", {
                                                                    type: "email",
                                                                    class: "form-control",
                                                                    id: 'color3' + _unref(instanceId),
                                                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((color3).value = $event))
                                                                }, null, 8, _hoisted_44), [
                                                                    [_vModelText, color3.value]
                                                                ]),
                                                                _createElementVNode("label", {
                                                                    for: 'color3' + _unref(instanceId)
                                                                }, "3. " + _toDisplayString(_unref(t)('Farbe')) + " (Hex-Code)", 9, _hoisted_45)
                                                            ])
                                                        ])
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (colorSelection.value == '2')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                                    _withDirectives(_createElementVNode("select", {
                                                        class: "form-select",
                                                        id: 'colorSchemeSelection-' + _unref(instanceId),
                                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((colorSchemeSelection).value = $event)),
                                                        required: ""
                                                    }, [
                                                        _createElementVNode("option", _hoisted_48, _toDisplayString(_unref(t)('Bitte Auswahl treffen')), 1),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colorSchemes.value, (scheme) => {
                                                            return (_openBlock(), _createElementBlock("option", {
                                                                key: scheme.id,
                                                                value: scheme.id
                                                            }, _toDisplayString(scheme.name), 9, _hoisted_49));
                                                        }), 128))
                                                    ], 8, _hoisted_47), [
                                                        [_vModelSelect, colorSchemeSelection.value]
                                                    ]),
                                                    _createElementVNode("label", {
                                                        for: 'colorSchemeSelection-' + _unref(instanceId)
                                                    }, _toDisplayString(_unref(t)('Farbschema')), 9, _hoisted_50)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ], 8, _hoisted_13),
                                        _createElementVNode("div", {
                                            class: "tab-pane fade",
                                            id: 'pills-print-area' + _unref(instanceId),
                                            role: "tabpanel",
                                            tabindex: "0"
                                        }, [
                                            _createElementVNode("p", _hoisted_52, _toDisplayString(_unref(t)('Ist das Druckbild für einen bestimmten Bereich gedacht?')), 1),
                                            _createElementVNode("div", _hoisted_53, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: 'printAreaSelection-' + _unref(instanceId),
                                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((printAreaSelection).value = $event)),
                                                    required: ""
                                                }, [
                                                    _createElementVNode("option", _hoisted_55, _toDisplayString(_unref(t)('Bitte Auswahl treffen')), 1),
                                                    _createElementVNode("option", _hoisted_56, _toDisplayString(_unref(t)('Egal')), 1),
                                                    _createElementVNode("option", _hoisted_57, _toDisplayString(_unref(t)('Komplettes Druckbild')), 1),
                                                    _createElementVNode("option", _hoisted_58, _toDisplayString(_unref(t)('Vorder- oder Rückseite')), 1)
                                                ], 8, _hoisted_54), [
                                                    [_vModelSelect, printAreaSelection.value]
                                                ]),
                                                _createElementVNode("label", {
                                                    for: 'printAreaSelection-' + _unref(instanceId)
                                                }, _toDisplayString(_unref(t)('Druckbereich')), 9, _hoisted_59)
                                            ])
                                        ], 8, _hoisted_51),
                                        _createElementVNode("div", {
                                            class: "tab-pane fade",
                                            id: 'pills-design-topic' + _unref(instanceId),
                                            role: "tabpanel",
                                            tabindex: "0"
                                        }, [
                                            _createElementVNode("p", _hoisted_61, _toDisplayString(_unref(t)('Welches Thema soll die Grafik beschreiben?')), 1),
                                            _createElementVNode("div", _hoisted_62, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: 'topicSelection-' + _unref(instanceId),
                                                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((topicSelection).value = $event)),
                                                    required: ""
                                                }, [
                                                    _createElementVNode("option", _hoisted_64, _toDisplayString(_unref(t)('Bitte Auswahl treffen')), 1),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(designTopics.value, (topic) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: topic.id,
                                                            value: topic.id
                                                        }, _toDisplayString(topic.name), 9, _hoisted_65));
                                                    }), 128))
                                                ], 8, _hoisted_63), [
                                                    [_vModelSelect, topicSelection.value]
                                                ]),
                                                _createElementVNode("label", {
                                                    for: 'topicSelection-' + _unref(instanceId)
                                                }, _toDisplayString(_unref(t)('Thema')), 9, _hoisted_66)
                                            ])
                                        ], 8, _hoisted_60),
                                        _createElementVNode("div", {
                                            class: "tab-pane fade",
                                            id: 'pills-design-type' + _unref(instanceId),
                                            role: "tabpanel",
                                            tabindex: "0"
                                        }, [
                                            _createElementVNode("p", _hoisted_68, _toDisplayString(_unref(t)('Welcher Grafik-Stil soll angewendet werden?')), 1),
                                            _createElementVNode("div", _hoisted_69, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: 'designTypeSelection-' + _unref(instanceId),
                                                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((designTypeSelection).value = $event)),
                                                    required: ""
                                                }, [
                                                    _createElementVNode("option", _hoisted_71, _toDisplayString(_unref(t)('Bitte Auswahl treffen')), 1),
                                                    _createElementVNode("option", _hoisted_72, _toDisplayString(_unref(t)('Egal')), 1),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(designTypes.value, (type) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: type.id,
                                                            value: type.id
                                                        }, _toDisplayString(type.name), 9, _hoisted_73));
                                                    }), 128))
                                                ], 8, _hoisted_70), [
                                                    [_vModelSelect, designTypeSelection.value]
                                                ]),
                                                _createElementVNode("label", {
                                                    for: 'designTypeSelection-' + _unref(instanceId)
                                                }, _toDisplayString(_unref(t)('Design-Stil')), 9, _hoisted_74)
                                            ])
                                        ], 8, _hoisted_67),
                                        _createElementVNode("div", {
                                            class: "tab-pane fade",
                                            id: 'pills-your-company' + _unref(instanceId),
                                            role: "tabpanel",
                                            tabindex: "0"
                                        }, [
                                            _createElementVNode("p", _hoisted_76, _toDisplayString(_unref(t)('Um die Grafik für Ihre Branche anzupassen, benötigen wir Ihre Branche.')), 1),
                                            _createElementVNode("div", _hoisted_77, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: 'industrySelection-' + _unref(instanceId),
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((industrySelection).value = $event)),
                                                    required: ""
                                                }, [
                                                    _createElementVNode("option", _hoisted_79, _toDisplayString(_unref(t)('Bitte Auswahl treffen')), 1),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(industries.value, (industry) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: industry.id,
                                                            value: industry.id
                                                        }, _toDisplayString(industry.name), 9, _hoisted_80));
                                                    }), 128))
                                                ], 8, _hoisted_78), [
                                                    [_vModelSelect, industrySelection.value]
                                                ]),
                                                _createElementVNode("label", {
                                                    for: 'industrySelection-' + _unref(instanceId)
                                                }, _toDisplayString(_unref(t)('Branche')), 9, _hoisted_81)
                                            ])
                                        ], 8, _hoisted_75),
                                        _createElementVNode("div", {
                                            class: "tab-pane fade",
                                            id: 'pills-application-area' + _unref(instanceId),
                                            role: "tabpanel",
                                            tabindex: "0"
                                        }, [
                                            _createElementVNode("p", _hoisted_83, _toDisplayString(_unref(t)('Ist Ihre Konfiguration für einen bestimmten Anwendungszweck bestimmt?')), 1),
                                            _createElementVNode("div", _hoisted_84, [
                                                _withDirectives(_createElementVNode("select", {
                                                    class: "form-select",
                                                    id: 'applicationAreaSelection-' + _unref(instanceId),
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((applicationAreaSelection).value = $event)),
                                                    required: ""
                                                }, [
                                                    _createElementVNode("option", _hoisted_86, _toDisplayString(_unref(t)('Bitte Auswahl treffen')), 1),
                                                    _createElementVNode("option", _hoisted_87, _toDisplayString(_unref(t)('Egal')), 1),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(applicationAreas.value, (area) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: area.id,
                                                            value: area.id
                                                        }, _toDisplayString(area.name), 9, _hoisted_88));
                                                    }), 128))
                                                ], 8, _hoisted_85), [
                                                    [_vModelSelect, applicationAreaSelection.value]
                                                ]),
                                                _createElementVNode("label", {
                                                    for: 'applicationAreaSelection-' + _unref(instanceId)
                                                }, _toDisplayString(_unref(t)('Anwendungsbereich')), 9, _hoisted_89)
                                            ])
                                        ], 8, _hoisted_82)
                                    ])
                                ]),
                                (progress.value < 100)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_90, _toDisplayString(_unref(t)('Bitte füllen Sie alle erforderlichen Felder aus, um fortzufahren.')), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_91, [
                                    _createElementVNode("button", {
                                        class: "btn btn-primary d-inline-flex align-items-center m-2",
                                        disabled: (progress.value < 100),
                                        onClick: _cache[14] || (_cache[14] = ($event) => (generateAiImages()))
                                    }, [
                                        _cache[17] || (_cache[17] = _createElementVNode("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "16",
                                            height: "16",
                                            fill: "currentColor",
                                            class: "bi bi-stars",
                                            viewBox: "0 0 16 16"
                                        }, [
                                            _createElementVNode("path", { d: "M7.657 6.247c.11-.33.576-.33.686 0l.645 1.937a2.89 2.89 0 0 0 1.829 1.828l1.936.645c.33.11.33.576 0 .686l-1.937.645a2.89 2.89 0 0 0-1.828 1.829l-.645 1.936a.361.361 0 0 1-.686 0l-.645-1.937a2.89 2.89 0 0 0-1.828-1.828l-1.937-.645a.361.361 0 0 1 0-.686l1.937-.645a2.89 2.89 0 0 0 1.828-1.828zM3.794 1.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387A1.73 1.73 0 0 0 4.593 5.69l-.387 1.162a.217.217 0 0 1-.412 0L3.407 5.69A1.73 1.73 0 0 0 2.31 4.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387A1.73 1.73 0 0 0 3.407 2.31zM10.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.16 1.16 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.16 1.16 0 0 0-.732-.732L9.1 2.137a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732z" })
                                        ], -1)),
                                        _createElementVNode("span", _hoisted_93, _toDisplayString(_unref(t)('Grafiken jetzt generieren')), 1)
                                    ], 8, _hoisted_92)
                                ]),
                                (generatedImages.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("h6", _hoisted_94, _toDisplayString(_unref(t)('Generierte Grafiken')), 1))
                                    : _createCommentVNode("", true),
                                (generatedImages.value.length > 0)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_95, _toDisplayString(_unref(t)('Anklicken zur Verwendung im Konfigurator.')), 1))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_96, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(generatedImages.value, (image, index) => {
                                        return (_openBlock(), _createElementBlock("div", _hoisted_97, [
                                            _createElementVNode("button", {
                                                onClick: ($event) => (selectImage(image.uuid)),
                                                class: "bg-light rounded border position-relative"
                                            }, [
                                                _createElementVNode("img", {
                                                    src: image.url,
                                                    class: "w-100 p-1"
                                                }, null, 8, _hoisted_99)
                                            ], 8, _hoisted_98)
                                        ]));
                                    }), 256))
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (loading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                                _createElementVNode("div", _hoisted_101, [
                                    _cache[18] || (_cache[18] = _createElementVNode("div", {
                                        class: "spinner-grow text-white mb-4",
                                        role: "status"
                                    }, [
                                        _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
                                    ], -1)),
                                    _createElementVNode("span", {
                                        class: "fs-5 fw-bold text-white text-center",
                                        innerHTML: _unref(trans)('Bitte warten!<br />Ihre Grafiken werden generiert')
                                    }, null, 8, _hoisted_102)
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        _createVNode(_Transition, null, {
                            default: _withCtx(() => [
                                (error.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_103, [
                                        _createElementVNode("div", _hoisted_104, [
                                            _createElementVNode("span", _hoisted_105, _toDisplayString(error.value), 1)
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                }, 8, ["id", "closeButton"])
            ], 64));
        };
    }
});
